import wixApplication from 'wix-application';
import * as utils from "public/t-utils.js"
import { get_data_back, get_data_back_jw } from "backend/t-back-utils.jsw"
import wixWindow from 'wix-window';

let data_arr = [];

let plan, instance;

$w.onReady(async function () {
    instance = await wixApplication.getDecodedAppInstance();
    plan = instance.vendorProductId;
    init_reg();
});

$widget.onPropsChanged(async (oldProps, newProps) => {
    if (wixWindow.viewMode === "Site" && plan !== "extra") return;

    if ((newProps.query !== oldProps.query) || (newProps.type !== oldProps.type)) {
        init();
    } else {
        if (data_arr.length === 0) return init();
        let settings = constructPropsObj(data_arr, $widget.props);
        $w("#customElement").setAttribute("settings", settings)
    }

});
async function init() {
    try {
        if (wixWindow.viewMode === "Site") data_arr = await utils.get_data($widget.props.type, $widget.props.query);
    } catch (err) {
        data_arr = [];
        console.log(err);
    }

    if (wixWindow.viewMode === "Editor" && $widget.props.query.length > 0 && $widget.props.type.length > 0) {
        data_arr = await get_data_back($widget.props.type, $widget.props.query);
        if (data_arr.length === 0) {
            $w("#loader").setAttribute("settings", JSON.stringify({ display: "block" }));
        }
        // console.log('1 data_arr 0', data_arr)
        if (data_arr.length === 0) {
            await retry($widget.props.type, $widget.props.query, 1);
            data_arr = await utils.get_data($widget.props.type, $widget.props.query);
        }
        // console.log('2 data_arr 0', data_arr)
        if (data_arr.length === 0) {
            data_arr = await get_data_back_jw($widget.props.type, $widget.props.query);
        }
    }
    let settings = constructPropsObj(data_arr, $widget.props);
    // console.log('3 data_arr', data_arr)
    $w("#customElement").setAttribute("settings", settings);
    $w("#loader").setAttribute("settings", JSON.stringify({ display: "none" }));
}
async function init_reg() {
    data_arr = await utils.get_data($widget.props.type, $widget.props.query);
    let settings = constructPropsObj(data_arr, $widget.props);
    $w("#customElement").setAttribute("settings", settings);
}

function constructPropsObj(data, props) {
    if (wixWindow.formFactor !== "Desktop") props = utils.overwriteWithMobileValues(props);
    if (data.length > 0) {
        data = filterIvalid_and_reorder(data);
        return JSON.stringify({
            data: data.slice(0, +$widget.props.numberOfPosts),
            props
        })
    } else return JSON.stringify({ data: [], props })
}

function filterIvalid_and_reorder(data) {
    const currentTime = Math.floor(Date.now() / 1000);
    const accessibleUrls = data.filter(item => {
        let urlObj = item.thumbnailURL || '';
        try {
            urlObj = new URL(item.thumbnailURL);
        } catch (error) {
            urlObj = undefined;
        }
        if (!urlObj) return true
        const expiresParam = urlObj.searchParams.get("x-expires");
        if (!expiresParam) return true
        return expiresParam && parseInt(expiresParam, 10) > currentTime;
    });
    return accessibleUrls.reverse();
}

function retry(type, query, attempt) {
    return new Promise((resolve, reject) => {
        const attemptRetry = () => {
            if (attempt === 10) {
                resolve(data_arr); // If max attempts reached, resolve with current data_arr
                return;
            }
            if (attempt % 2 == 0) {
                $w("#html1").src = `https://storage.elfsight.com/api/tiktok?type=${type}&query=${query}`;
                $w("#html2").src = `https://`;
                setTimeout(() => {
                    retry(type, query, attempt + 1).then(resolve).catch(reject);
                }, 1200);

            } else {
                $w("#html2").src = `https://storage.elfsight.com/api/tiktok?type=${type}&query=${query}`;
                $w("#html1").src = `https://`;
                setTimeout(() => {
                    retry(type, query, attempt + 1).then(resolve).catch(reject);
                }, 1200);
            }
        };
        attemptRetry();
    });
}